import { render, staticRenderFns } from "./payments.vue?vue&type=template&id=753cf018"
import script from "./payments?vue&type=script&lang=js&external"
export * from "./payments?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports